const ANALYTICS_DATE_PARAM_KEYS = ["analyticsFrom", "analyticsTo"] as const;

export function copyAnalyticsDateParams(
  source: URLSearchParams,
  target: URLSearchParams,
): void {
  ANALYTICS_DATE_PARAM_KEYS.forEach((key) => {
    const value = source.get(key);
    if (value) {
      target.set(key, value);
    }
  });
}
